import React, { useState } from 'react';



export const shelf_recalculate_prices = (shelf) => {
    let price = 0;
    for (let i = shelf.length - 1; i >= 0; i--) {
        shelf[i].output_price = price;
        price += 1;
    }
}